import React from 'react';
import { ShieldCheck, Globe, CheckCircle2, ExternalLink, Info } from 'lucide-react';

export default function RegistryVerification({ project }) {
    return (
        <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 md:p-8 border border-emerald-100 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-emerald-600 rounded-xl">
                    <ShieldCheck className="text-white" size={24} />
                </div>
                <div>
                    <h3 className="text-lg font-black text-gray-900 uppercase tracking-tight">Registry Verification</h3>
                    <p className="text-xs text-gray-600 font-medium">Independently verified carbon credits</p>
                </div>
                {project.verificationStatus === 'Verified' && (
                    <div className="ml-auto flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-full text-xs font-black uppercase tracking-wider">
                        <CheckCircle2 size={14} />
                        Verified
                    </div>
                )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                    <div>
                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-1">Registry Name</p>
                        <p className="text-sm font-bold text-gray-900 uppercase">{project.registryName}</p>
                    </div>
                    <div>
                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-1">Registry ID</p>
                        <p className="text-sm font-bold text-gray-900 uppercase">{project.registryID}</p>
                    </div>
                    <div>
                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-1">Verification Body</p>
                        <p className="text-sm font-bold text-gray-900 uppercase">{project.verificationBody}</p>
                    </div>
                    <div>
                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-1">Project Status</p>
                        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-black uppercase tracking-wider ${
                            project.projectStatus === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-700'
                        }`}>
                            <span className={`w-2 h-2 rounded-full ${project.projectStatus === 'Active' ? 'bg-emerald-500 animate-pulse' : 'bg-gray-500'}`}></span>
                            {project.projectStatus}
                        </span>
                    </div>
                </div>

                <div className="space-y-4">
                    <div>
                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-1">Credits Issued</p>
                        <p className="text-2xl font-black text-gray-900 uppercase">{project.creditsIssued.toLocaleString()} <span className="text-sm font-bold text-gray-500">tCO₂e</span></p>
                    </div>
                    <div>
                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-1">Credits Available</p>
                        <p className="text-2xl font-black text-emerald-600 uppercase">{project.creditsAvailable.toLocaleString()} <span className="text-sm font-bold text-gray-500">tCO₂e</span></p>
                    </div>
                    <a
                        href={project.registryUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-xs font-black uppercase tracking-wider transition-all group"
                    >
                        <Globe size={16} />
                        Verify on Registry
                        <ExternalLink size={14} className="group-hover:translate-x-0.5 transition-transform" />
                    </a>
                </div>
            </div>
        </div>
    );
}
